const joinTeamData = [
  {
    id: "1",
    title: "Competitive Benefits",
    details:
      "Health insurance, performance bonuses, and professional development allowance",
  },
  {
    id: "2",
    title: "Career Growth",
    details:
      "Clear advancement paths and mentorship programs for all experience levels",
  },
  {
    id: "3",
    title: "Modern Workplace",
    details:
      "State-of-the-art office with latest technology and flexible work arrangements",
  },
];

export default joinTeamData;
